import React from "react";

import { IInfoCardProps } from "./info-card.types";
import {
  InfoCardSubtitle,
  InfoCardTitle,
  InfoCardWrapper,
  InfoCardInfoWrapper,
  InfoCardContainer,
  InfoContainer,
  InfoCardHeading,
  InfoBold,
  InfoNormal,
  InfoBoldNumber,
  InfoBoldText,
  InfoBulletin,
  TickWrapper,
  ImageContainer1,
  ImageContainer2
} from "./info-card.styles";
import CheckIcon from "public/assets/check_circle.png";

export const InfoCard: React.FC<IInfoCardProps> = ({
  title,
  subtitle,
  info,
  boldStyle,
  backgroundColor,
  isCompact = false
}) => {
  return (
    <InfoCardWrapper
      backgroundColor={backgroundColor || "white"}
      $isCompact={isCompact}
    >
      <InfoContainer>
        <InfoCardHeading>
          <InfoCardTitle>{title}</InfoCardTitle>
          {subtitle && <InfoCardSubtitle>{subtitle}</InfoCardSubtitle>}
        </InfoCardHeading>
        <InfoCardInfoWrapper $isCompact={isCompact}>
          {info.map((item, index) => {
            const isSingleLine = item.normal.length === 1;
            const boldContent =
              typeof item.bold === "string" ? { text: item.bold } : item.bold;

            return (
              <InfoCardContainer
                key={index}
                padding={item.normal.length > 1 ? "2px" : "8px"}
              >
                {isSingleLine && (
                  <TickWrapper>
                    <ImageContainer1 src={CheckIcon} alt="bullet" />
                  </TickWrapper>
                )}

                <InfoBulletin style={{ flex: 1 }}>
                  {/* Display bold content */}
                  <InfoBold style={boldStyle}>
                    <InfoBoldNumber>
                      {boldContent.number && (
                        <span style={{ fontWeight: "800", marginRight: "8px" }}>
                          {boldContent.number}
                        </span>
                      )}
                    </InfoBoldNumber>
                    <InfoBoldText>{boldContent.text}</InfoBoldText>
                  </InfoBold>

                  <div className="info-bulletin">
                    {item.normal.map((text, idx) => (
                      <div
                        key={idx}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        {!isSingleLine && (
                          <ImageContainer2 src={CheckIcon} alt="bullet" />
                        )}
                        <InfoNormal
                          dangerouslySetInnerHTML={{
                            __html: text
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </InfoBulletin>
              </InfoCardContainer>
            );
          })}
        </InfoCardInfoWrapper>
      </InfoContainer>
    </InfoCardWrapper>
  );
};
